module.exports = __webpack_public_path__ + "img/45.0ca7d1cf.jpg";